<template>
  <div class="container">
    <h1>We're not quite ready!</h1>
    <div class="main">
      <SignupComp />
    </div>
  </div>
</template>

<script>
import SignupComp from './signup-comp'
export default {
  name: 'UnderConstructionPage',
  components: {
    SignupComp,
  },
}
</script>

<style></style>
